exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".shopDetailContainer {\n  margin-top: 20px; }\n  .shopDetailContainer .content {\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 5px;\n    height: calc(100vh - 150px - 20px - 10px - 70px); }\n  .shopDetailContainer .paperContainer {\n    padding: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/shops/detail/bussniesHours/BussniessHours.scss
// module id = 1710
// module chunks = 0